import React, { useRef, useImperativeHandle } from 'react';
import TimelineRow from './TimelineRow';
import dayjs from 'dayjs';

const TimelineBoard = React.forwardRef(({
    docks,
    reservations,
    visibleStart,
    visibleDurationMins,
    pxPerMin,
    statusConfig,
    onTimeScroll,
    onEventClick,
    onEventContextMenu,
    canEdit = true
}, ref) => {
    const bodyRef = useRef(null);

    useImperativeHandle(ref, () => ({
        scrollBy: (pixels) => {
            if (bodyRef.current) {
                bodyRef.current.scrollBy({ left: pixels, behavior: 'smooth' });
            }
        }
    }));

    // Generate Hour Headers for visible duration (8 hours)
    const hours = [];
    const totalHours = visibleDurationMins / 60;

    for (let i = 0; i < totalHours; i++) {
        const timeStr = dayjs(visibleStart).add(i, 'hour').format('HH:mm');
        hours.push(
            <div
                key={i}
                className="time-slot-header"
                style={{
                    left: i * 60 * pxPerMin,
                    width: 60 * pxPerMin,
                    borderRight: '1px solid var(--border-color)'
                }}
            >
                {timeStr}
            </div>
        );
    }

    const enhancedReservations = reservations.map(r => ({
        ...r,
        statusConfig: statusConfig[r.status] || statusConfig['pending']
    }));

    return (
        <div className="timeline-container" style={{ width: '100%' }}>
            {/* Header Row */}
            <div className="timeline-header-row" style={{
                display: 'flex',
                height: '50px',
                borderBottom: '2px solid var(--border-color)',
                background: 'var(--bg-secondary)',
                position: 'sticky',
                top: 0,
                zIndex: 30
            }}>
                {/* Fixed Sidebar with Nav Buttons */}
                <div className="row-sidebar flex items-center justify-center gap-1 p-0" style={{
                    zIndex: 31,
                    borderRight: '1px solid var(--border-color)',
                    background: 'var(--bg-secondary)',
                    width: '80px',
                    minWidth: '80px',
                    flexShrink: 0
                }}>
                    <button
                        onClick={(e) => { e.stopPropagation(); onTimeScroll(-1); }}
                        className="glass-timeline-nav-btn"
                        title="4 Saat Geri"
                    >
                        ≪
                    </button>
                    <button
                        onClick={(e) => { e.stopPropagation(); onTimeScroll(1); }}
                        className="glass-timeline-nav-btn"
                        title="4 Saat İleri"
                    >
                        ≫
                    </button>
                </div>
                {/* Header Content */}
                <div
                    className="row-content"
                    style={{
                        flex: 1,
                        position: 'relative',
                        height: '100%'
                    }}
                >
                    {hours}
                </div>
            </div>

            {/* Body - No horizontal scroll */}
            <div
                ref={bodyRef}
                className="timeline-body"
                style={{
                    flex: 1,
                    overflowY: 'auto',
                    overflowX: 'hidden'
                }}
            >
                {/* Rows */}
                {docks.map(dock => (
                    <TimelineRow
                        key={dock.id}
                        dock={dock}
                        reservations={enhancedReservations}
                        pxPerMin={pxPerMin}
                        visibleStart={visibleStart}
                        visibleDurationMins={visibleDurationMins}
                        onEventClick={onEventClick}
                        onEventContextMenu={onEventContextMenu}
                        canEdit={canEdit}
                    />
                ))}
            </div>
        </div>
    );
});

export default TimelineBoard;
